import axiosClient from "../../http-common";

class EntitiesApiService {
  /**
   * Returns a list which describes, whether a slot in this entity is occupied or available for selection
   *
   * 
   * @param {string} tenantId - The tenant id.
   * @param {string} containerId - The container id.
   * @param {string} entityName - The name of the entity.
   * @returns {Promise} - The response of the API call.
   */
  getEntityOccupancy = async (tenantId, containerId, entityName) => {
    return await axiosClient.get(
      `api/V1/Tenants/${tenantId}/Containers/${containerId}/Entities/${entityName}/Occupancy`
    );
  };
}

export default new EntitiesApiService();
